export const NUM_NEARBY_CITIES_PROS_PER_PAGE = 12;
export const NUM_NEARBY_CITIES_PROS_PER_PAGE_OVER_PAGE2 = 20;
